import { Base64 } from "js-base64";

const BaseList = [
  "firstName",
  "lastName",
  "residenceCountryISO2",
  "residenceCountryName",
  "provinceCode",
  "provinceName",
  "mobileCountryISO2",
  "mobile",
  "areaNumber",
  "email",
  "dateOfBirth"
];

export const Base64Decode = (profile) => {
  if (profile?.constructor === Object) { 
    BaseList.forEach(x => {
      const item = profile[x];
      if (item) profile[x] = Base64.decode(item);
    })
  }
  return profile
}

export const Base64DecodePlainObjByFilter = (obj:Record<string,string>,...rest:string[]) => {
   if(Object.keys(obj).length > 0){
    rest.forEach(k => {
      if(obj[k]) {
        obj[k] = Base64.decode(obj[k])
      }
    })
    return obj
   }
}